"use client";
import { AppRoutes } from "@/lib/routeResolver";

import { Swiper, SwiperSlide } from "swiper/react";
import Link from "@/components/Link";
import type { HomeArticle, BlogSection } from "@/lib/navigation";
import ArticleCard from "@/app/(main)/components/ArticleCard";

import "swiper/css";

const DEFAULT_SUB_TITLE = "Central Holidays";
const DEFAULT_TITLE = "News & Articles";

interface BlogSliderProps {
  articles: HomeArticle[];
  /** CMS header copy; each field falls back to the static copy when empty. */
  section?: BlogSection;
}

export default function BlogSlider({ articles, section }: BlogSliderProps) {
  const subTitle = section?.subTitle || DEFAULT_SUB_TITLE;
  const title = section?.title || DEFAULT_TITLE;

  if (!articles || articles.length === 0) return null;

  return (
    <section
      className="bg-smoke overflow-hidden space overflow-hidden"
      id="blog-sec"
    >
      <div className="container">
        <div className="mb-30 text-center text-md-start">
          <div className="row align-items-center justify-content-between">
            <div className="col-md-7">
              <div className="title-area mb-md-0">
                <span className="sub-title">{subTitle}</span>
                <h2 className="sec-title">{title}</h2>
              </div>
            </div>
            <div className="col-md-auto">
              <Link
                href="/Newsroom-Media/Travel-Articles"
                className="th-btn style4 th-icon"
                title="See more travel articles"
              >
                See More Articles
              </Link>
            </div>
          </div>
        </div>
        <div className="slider-area">
          <Swiper
            className="th-slider has-shadow"
            loop={true}
            spaceBetween={16}
            breakpoints={{
              0: { slidesPerView: 1 },
              576: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              992: { slidesPerView: 2 },
              1200: { slidesPerView: 3 },
            }}
          >
            {articles.map((art) => (
              <SwiperSlide key={art.id}>
                <ArticleCard
                  title={art.title}
                  photo={art.photoURL}
                  href={AppRoutes.article(art.pageURL)}
                  date={art.createdDate}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
}
